import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { LocationDetailsSession } from '../../api/models/locationDetailsSession';
import { PickupDetailsSession } from '../../api/models/pickupDetailsSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, CommonConstants, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { DAYCODE_TRANSLATION, DAY_OF_WEEK, LAPSE_TIME_INCREMENT, PICKUP_TYPE, SCHEDULE_ERROR_MESSAGES } from '../../constants/upplm.constants.pickupdetails';
import { UPPLM_TRANSLATIONS } from '../../constants/upplm.constants.translations';
import { Error } from '../../interface/upplm.common.interface';
import { AvailableDayAndService, ErrorSchedule, GenericSchedule, GetPickupScheduleDetailsRequest, PickupScheduleDetailResponse, PickupType, PickupTypePlan, ScheduleDetailToSave, ScheduleListDDL } from '../../interface/upplm.pickupdetails';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';


@Component({
    selector: 'pickupdetails',
    template: require('./pickupDetails.component.html'),
    styles: ['.errorTimeMessage{float: right;padding-left: 21px;padding-right: 30px;top: -10px;}']
})

export class PickupDetailsComponent implements OnInit, AfterViewInit {
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = true;
    private _getPickupScheduleDetailsRequest: GetPickupScheduleDetailsRequest;
    private _getPickupScheduleDetailsResponse: PickupScheduleDetailResponse;
    public _pickupPlanTypes: any[];
    allSchedule: GenericSchedule[];
    textMessagePickup: string;
    textSmartMessagePickupFooter: string;
    isPickupTypeSelected: boolean;
    isSmartPickupTypeSelected: boolean;
    isPickupSaturday: boolean;

    //Hold if the option for Saturday's toggle is available and shown
    isSaturdayAvailable: boolean;
    pickupTypeSelectedValue: string = '-1';
    validateMessageModify: boolean = true;

    Errors: ErrorSchedule[];
    pickupTypeClass: string = 'ups-dropdown ng-touched ng-dirty ng-valid';
    scheduleDetails: ScheduleDetailToSave[];
    chkPickupSaturdayVisible: boolean;
    validationSelectDapSmp: boolean = false;
    globalRegionCountry: string = 'NA';

    constructor(
        private _commonService: UpsCommonService,
        private router: Router,
        private _sessionService: UpplmSessionService,
        private _pbService: ProgressBarService,
        private _apiService: UpplmApiService,
        private _utagService: UtagService,
        private _translateData: TranslateDataPipe) {
        this._getPickupScheduleDetailsResponse = new PickupScheduleDetailResponse();
        this.isPickupTypeSelected = false;
        this.isSmartPickupTypeSelected = false;
        this.textSmartMessagePickupFooter = '';//SMART_PICKUP_NOTE;
    }

    ngOnInit() {
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_PICKUP_DETAILS_START, UTagConstants.UPPLM_PICKUP_DETAILS_START_SCREEN);
        this.isInitialLoadding = true;
        this.globalRegionCountry = this._commonService.getRegionCountry(this._commonService.locale_country);
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;               
                this._sessionService.mapSessionResponse(response);

                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                }

                let data: PickupDetailsSession = new PickupDetailsSession(); // the session
                data = this.sessionData.pickupDetails;

                if (data.showPageEdit) {
                    //this is not necesary  begin the call validations of the servicees and restart the validations properities
                    this.validateMessageModify = true;
                    this.sessionData.pickupDetails.availableDays.forEach(element => {
                        if (element.validTime === false) {
                            this.validateMessageModify = element.validTime;
                            return;
                        }
                    });
                    this.getPickupScheduleDetails();
                    this.initializeForm();
                }
                else {
                    this.getPickupScheduleDetails();                   
                    this.bindDataFromSession(this.sessionData.pickupDetails);
                    if (this.sessionData.pickupDetails.pickupType !== '-1') {
                        this.isPickupTypeSelected = true;
                        this.textMessagePickup = this.getMessagePickupType(this.sessionData.pickupDetails.pickupType);
                        this.validationSelectDapSmp = true;
                    }
                }
            } else {
                this.SessionErrorModal.open();
            }
            this.isInitialLoadding = false;                         
        });
    }

    getMessagePickupType(pickupType: string): string {
        let translateValue: string = '';
        if (pickupType === PICKUP_TYPE.SMP) {
            translateValue = UPPLM_TRANSLATIONS.find(x => x.key === 'upplm.common.smp').default
        } else if (pickupType === PICKUP_TYPE.DSP) {
            translateValue = this._translateData.transform('upplm.pickupdetails.dsp')
        } else if (pickupType === PICKUP_TYPE.DAP) {
            translateValue = this._translateData.transform('upplm.common.dap')
        }
        return translateValue;
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        if (update) {
            let data = new PickupDetailsSession();
            data.allSchedule = this.allSchedule;
            data.availableDays = this._getPickupScheduleDetailsResponse.availableDaysAndServices;
            data.pickupType = this.pickupTypeSelectedValue;
            data.pPlanTypes = this._getPickupScheduleDetailsResponse.pickupPlanTypes;
            data.saturdayToogle = this.isPickupSaturday;
            request.pickupDetails = data;
        }
        else {
            request.pickupDetails = this.sessionData.pickupDetails;
        }
        this.pbDetails.showStatusBar = this._pbService.pb.showStatusBar;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    bindDataFromSession(data: PickupDetailsSession) {
        this.pickupTypeSelectedValue = data.pickupType;
        if (data.pickupType !== '-1') {
            this.getPickupTypePlan(data.pPlanTypes);
            this.setGlobalPickupScheduleDetails(data.pPlanTypes, data.availableDays, null);
            this.validateSaturdayAvailability(data.availableDays);

            if (data.allSchedule.length === 6) {
                this.isPickupSaturday = true;
            } else {
                this.isPickupSaturday = data.saturdayToogle;
            }
            this.allSchedule = data.allSchedule.map(item => ({ ...item }));
        }
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateData.transform('upplm.common.sessiontimedouttitle')
        });
        this.SessionErrorModal.setProperties({
            title: this._translateData.transform('upplm.common.serviceerror')
        });  
    }

    validateSessionAndNavigate(target: string, isUpdate: boolean) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.isLoadding = true;
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(isUpdate)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    nextPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.validatePage();
            if (typeof this.Errors !== "undefined" && this.Errors.length == 0) {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.locationPB = "true";
                this._pbService.pb.contactPB = "true";
                this._pbService.pb.placardPB = "true";
                this._pbService.pb.pickupPB = "true";
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_NOTIFICATION_DETAILS_ROUTE, true);
            }
        }
    }

    backPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.locationPB = "true";
            this._pbService.pb.contactPB = "true";
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_DETAILS_ROUTE, true);
        }
    }

    saveGoReviewPage() {
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }
        this.validatePage();
        if (this.Errors.length == 0) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE, true);
        }
    }

    cancelGoReviewPage() {
        if (!this.validateMessageModify) {
            this.validatePage();
            if (typeof this.Errors !== "undefined" && this.Errors.length == 0) {
                this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
            }
        }
        else {
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE, false);
        }
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    getPickupScheduleDetails() {
        let data: PickupDetailsSession = new PickupDetailsSession(); // the session
        data = this.sessionData.pickupDetails;
        this.getPickupTypePlan(data.pPlanTypes);
        this.setGlobalPickupScheduleDetails(data.pPlanTypes, data.availableDays, data.errors);
        this.validateSaturdayAvailability(data.availableDays);
    }

    setGlobalPickupScheduleDetails(pPlanTypes: PickupTypePlan[], availableDays: AvailableDayAndService[], errors: Error[]) {
        this._getPickupScheduleDetailsResponse.availableDaysAndServices = availableDays;
        this._getPickupScheduleDetailsResponse.pickupPlanTypes = pPlanTypes;
        this._getPickupScheduleDetailsResponse.errors = errors;
    }

    getPickupTypePlan(pPlanTypes: PickupTypePlan[]) {

        let pickupPlanTypes: PickupType[] = [] ;

        pPlanTypes.forEach(function (pickup) {
            let pickupType: PickupType = {
                id: pickup.pickupPlanType,
                description: this.getPickupTypeDescription(pickup.pickupPlanType)
            };
            pickupPlanTypes.push(pickupType);
        }, this);
        this._pickupPlanTypes = pickupPlanTypes;
    }

    getPickupTypeDescription(pickupTypeId: string): string {
        let translatedValue: string = '';
        if (pickupTypeId === PICKUP_TYPE.SMP) {
            translatedValue = this._translateData.transform('upplm.pickupdetails.pickuptypeplan.smp');
        } else if (pickupTypeId === PICKUP_TYPE.DAP) {
            translatedValue = this._translateData.transform('upplm.pickupdetails.pickuptypeplan.dap');
        } else if (pickupTypeId === PICKUP_TYPE.DSP) {
            translatedValue = this._translateData.transform('upplm.pickupdetails.pickuptypeplan.dsp');
        }
        return translatedValue;
    }

    showPickupTypeText(ddTypeSelected) {
        //Show the message below the dropdown
        this.textMessagePickup = this.getMessagePickupType(ddTypeSelected);
        //Show or hide the PickupTypeSeleted usng *ngIF
        ddTypeSelected != "-1"
            ? (this.isPickupTypeSelected = true)
            : (this.isPickupTypeSelected = false);
        //Show or hide the SmartNote usng *ngIF
        ddTypeSelected == PICKUP_TYPE.SMP ? (this.isSmartPickupTypeSelected = true) : (this.isSmartPickupTypeSelected = false);

        this.pickupTypeSelectedValue = ddTypeSelected;


        if (ddTypeSelected != "-1") {
            if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
                if (this.allSchedule !== undefined) {
                    if (this.allSchedule.length >= 0) {
                        this.validationSelectDapSmp = false;
                    }
                }
            }
            this.Errors = [];
            this.executePickupFlow();

        } else {
            this.initializeForm();
        }
    }

    initializeForm() {
        this.isPickupSaturday = false;
        this.pickupTypeSelectedValue = '-1';
        this.Errors = [];
    }

    activateSaturdayChk(event: Event) {
        this.isPickupSaturday = (<HTMLInputElement>event.target).checked;
        this.executePickupFlow();
    }

    validateSaturdayAvailability(availableDays: AvailableDayAndService[]) {
        let result: boolean = false;
        availableDays.forEach(function (day) {
            result = day.dayOfWeekCode == DAY_OF_WEEK.SATURDAY ? true : false;
        });
        this.isSaturdayAvailable = result;
        this.chkPickupSaturdayVisible = this.isSaturdayAvailable;
    }

    getScheduleData(days: number, preferredDrops: number, latestDrops: number) {
        //----------------------------------------------------------------------------------
        //------ dropdowns selected when change option main
        //----------------------------------------------------------------------------------
        var i = 1;
        let validationDapSmp = false;
        if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
            if (this.validationSelectDapSmp && this.allSchedule !== undefined) {
                i = days;
                validationDapSmp = this.setAllSchedule(days);
            } else {
                this.validationSelectDapSmp = true;
                this.allSchedule = [];
            }
        } else {
            this.allSchedule = [];
        }

        if (validationDapSmp) {
            return;
        }

        for (i; i <= days; i++) {
            let schedule: GenericSchedule = new GenericSchedule();
            let dayAndService: AvailableDayAndService;
            schedule.day = this._translateData.transform(DAYCODE_TRANSLATION[i-1].key);
            schedule.shortDay = CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[i - 1];

            switch (i) {
                case 1:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.MONDAY)[0];
                    break;
                case 2:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.TUESDAY)[0];
                    break;
                case 3:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.WEDNESDAY)[0];
                    break;
                case 4:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.THURSDAY)[0];
                    break;
                case 5:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.FRIDAY)[0];
                    break;
                case 6:
                    dayAndService = this._getPickupScheduleDetailsResponse.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.SATURDAY)[0];
                    break;
            }
            schedule.dayOfWeekCode = dayAndService.dayOfWeekCode;

            if (i <= preferredDrops) {
                schedule.preferredTime = this.getScheduleList(dayAndService.preferredTime.startTime, dayAndService.preferredTime.endTime);
            }
            if (i <= latestDrops) {
                schedule.latestTime = this.getScheduleList(dayAndService.latestTime.startTime, dayAndService.latestTime.endTime);
            }
            schedule.latestSelected = "-1";
            schedule.preferredSelected = "-1";
            this.allSchedule.push(schedule);
        }
    }

    setAllSchedule(numberOfDays: number): boolean {
        if (this.allSchedule.length === 6 && numberOfDays === 5) {
            this.allSchedule = this.allSchedule.slice(0, this.allSchedule.length - 1);
            return true;
        } else {
            return false;
        }
    }

    executePickupFlow() {


        this.chkPickupSaturdayVisible = this.isSaturdayAvailable;
        let saturday = this.isSaturdayAvailable ? (this.isPickupSaturday ? true : false) : false;

        if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
            if (saturday) {
                this.getScheduleData(6, 6, 6);
            } else {
                this.getScheduleData(5, 5, 5);
            }
        }
        else if (this.pickupTypeSelectedValue === PICKUP_TYPE.DSP) {
            if (this.isSaturdayAvailable) {
                this.getScheduleData(6, 6, 6);
            }
            else {
                this.getScheduleData(5, 5, 5);
            }
        }
    }

    //Gets the time range for a dropdown
    getScheduleList(startTime: string, endTime: string) {
        let scheduleList = [];
        let myScheduleListDDL = [];
        let currentProcesingTime: Date = this.getDateValueFromString(startTime);
        let nextTimeToProcess: Date = currentProcesingTime;
        let initialValue: boolean = true;
        let hour: number;
        let minute: number;
        let finalTime: Date = this.getDateValueFromString(endTime);

        while (this.evaluateDate(nextTimeToProcess, finalTime)) {

            currentProcesingTime = nextTimeToProcess;
            hour = Number(currentProcesingTime.getHours());
            minute = Number(currentProcesingTime.getMinutes());
            if (!initialValue) {
                scheduleList.push(hour.toString().concat(':', minute < 10 ? '0' + minute.toString() : minute.toString())); //Insert in the array if it's a valid time
            }
            else {//Always insert the fist time of the schedule result
                scheduleList.push(startTime);
                initialValue = false;
            }

            //Take the last value inserted in the time array to evaluate if it's a valid time
            let splitLastTime = scheduleList[scheduleList.length - 1].split(':');
            let lasthour = Number(splitLastTime[0]);
            let lastminute = Number(splitLastTime[1]);

            finalTime = this.getDateValueFromString(endTime); //Ensure always the finaltime is older (milliseconds are taken when calculates difference)
            //Increment the next time to evaluate
            nextTimeToProcess = this.getDateValueFromString(this.convertAndincrementHour(lasthour, lastminute).toString());
        }

        for (var i = 0; i < scheduleList.length; i++) {
            let oScheduleList: ScheduleListDDL = new ScheduleListDDL();
            oScheduleList.unformattedTime = scheduleList[i].toString();
            oScheduleList.formattedTime = this._commonService.formatAMPM(scheduleList[i].toString());
            myScheduleListDDL.push(oScheduleList);
        }
        return myScheduleListDDL;
    }

    getDateValueFromString(timeToConvert: string): Date {
        let convertedDate = new Date();
        let timeValues = timeToConvert.split(':');
        let hourValue = Number(timeValues[0]);
        let minuteValue = Number(timeValues[1]);
        convertedDate.setHours(hourValue);
        convertedDate.setMinutes(minuteValue);
        return convertedDate;
    };

    evaluateDate(dateToEvaluate1: Date, dateToEvaluate2: Date) {//Return True if initial is Grater than final
        let result = false;

        if (dateToEvaluate1.getTime() <= dateToEvaluate2.getTime()) {
            result = true;
        }
        return result;
    };

    //Given an hour and minute, calculate the time lapse and returns a valid hour in string format
    convertAndincrementHour(hour: number, minute: number): string {

        let strTime: string = '';
        let timeToIncrease = LAPSE_TIME_INCREMENT * 60000; //Time to increase in milliseconds

        let dateTime = new Date(); //Create date from provided hour

        //set the provided hour and minute
        dateTime.setHours(hour);
        dateTime.setMinutes(minute);
        let calculatedDate = new Date(dateTime.getTime() + timeToIncrease); //Calcuate the sum of time + increase time
        strTime = calculatedDate.getHours().toString().concat(':', calculatedDate.getMinutes() < 10 ? '0' + calculatedDate.getMinutes().toString() : calculatedDate.getMinutes().toString());

        return strTime;
    }

    //Return 1 if Preferred Time is not an hour before Latest Time or Preferred > Latest
    //Return 2 if Latest Time is not an hour after Earliest Time
    //Return 0 if no error
    validateOneHourDifference(preferredHour: string, latestHour: string) {

        let result: number = 0;
        let preferredDate = new Date();
        let latestDate = new Date();

        let preferredValues = preferredHour.split(':');
        let preferredHourValue = Number(preferredValues[0]);
        let preferredMinuteValue = Number(preferredValues[1]);

        let latestValues = latestHour.split(':');
        let latestHourValue = Number(latestValues[0]);
        let latestMinuteValue = Number(latestValues[1]);

        preferredDate.setHours(preferredHourValue);
        preferredDate.setMinutes(preferredMinuteValue);

        latestDate.setHours(latestHourValue);
        latestDate.setMinutes(latestMinuteValue);

        let diffLatestMinusPreferred = (latestDate.getTime() - preferredDate.getTime()) / 1000;
        diffLatestMinusPreferred /= (60 * 60);

        if (preferredDate.getTime() > latestDate.getTime()) {
            result = 1;
        }
        else if (diffLatestMinusPreferred < 1) {
            result = 2;
        }
        else {
            result = 0;
        }

        return result;
    }

    // Dynamically disable invalid latest time dropdown options
    disableLatestTimes(schedule: GenericSchedule) {
        if (schedule.preferredSelected === "-1") {
            return;
        }
        schedule.latestTime.forEach((DDL) => {
            let result = this.validateOneHourDifference(schedule.preferredSelected, DDL.unformattedTime);
            DDL.isdisabled = result != 0 ? true : false;
        });
    }

    validatePage() {
        this.Errors = [];
        this.validatePickupTypeNeeded();
        if (this.pickupTypeSelectedValue == 'DSP') {
            this.validateDSP();
            this.Errors = this.removeDuplicates(this.Errors, 'message');
            this.validateBusinessDays();
        } else {
            if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
                for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                    this.validatePickupTime(i);
                }
            }
            this.Errors = this.removeDuplicates(this.Errors, 'message');
        }
        this.focusHandler();
    }

    addPickupTypeGeneralError() {
        let errorGeneral = new ErrorSchedule();
        errorGeneral.message = this._translateData.transform('upplm.pickupdetails.error.picktype_general');
        errorGeneral.code = 'PICK_TYPE_GENERAL';
        errorGeneral.position = -2;
        this.Errors.push(errorGeneral);
        if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
            for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                this.allSchedule[i].error = new ErrorSchedule();
            }
        }
    }

    validateDSP() {
        const validateDays = this.allSchedule.filter(x => x.selectedDay == true || x.latestSelected !== '-1' || x.preferredSelected !== '-1');
        if (validateDays.length > 0) {
            if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
                for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                    if (this.allSchedule[i].selectedDay || this.allSchedule[i].latestSelected !== '-1' || this.allSchedule[i].preferredSelected !== '-1') {
                        this.validatePickupTime(i);
                    } else {
                        this.allSchedule[i].error = new ErrorSchedule();
                    }
                }
            }
        } else {
            this.addPickupTypeGeneralError();
        }
    }

    validatePickupTypeNeeded() {
        let errorPickupNeeded = new ErrorSchedule();
        if (this.pickupTypeSelectedValue == '-1') {
            errorPickupNeeded.message = this._translateData.transform('upplm.pickupdetails.error.picktype_1');
            errorPickupNeeded.code = 'PICK_TYPE_11';
            errorPickupNeeded.position = -1;
            errorPickupNeeded.id = "pickupNeeded";

            let findExistingError = this.Errors.find(err => err.code === errorPickupNeeded.code);
            //If no error code found in the list, then add to the error list
            if (!(typeof findExistingError !== "undefined" && findExistingError.code.length > 0)) {
                this.Errors.push(errorPickupNeeded);
            }
        }
    }

    focusHandler() {
        this.pickupTypeClass = this.pickupTypeSelectedValue != '-1' ? 'ups-dropdown ng-touched ng-dirty ng-valid' : 'ups-dropdown ng-touched ng-dirty ups-bodError ng-invalid';
    }

    removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }

    validatePickupTime(position) {
        let result = 0;

        switch (this.pickupTypeSelectedValue) {
            case "DSP":
                result = this.validateScheduleDSP(position);
                break;
            case "DAP":
            case "SMP":
                let preferred =
                    this.allSchedule[position].preferredSelected != "-1" ? "1" : "0";
                let latest =
                    this.allSchedule[position].latestSelected != "-1" ? "1" : "0";
                let option = preferred.concat(latest);

                if (option == "00") {
                    this.addToListError("SMP_DAP_3", position);
                } else if (option == "01") {
                    this.addToListError("SMP_DAP_1", position);
                } else if (option == "10"
                ) {
                    this.addToListError("SMP_DAP_2", position);
                } else {
                    if (typeof this.Errors != 'undefined') {
                        this.Errors = this.removeFixedErrors(position);
                    }

                    result = this.validateOneHourDifference(
                        this.allSchedule[position].preferredSelected,
                        this.allSchedule[position].latestSelected
                    );
                }
                break;
        }
        switch (result) {
            case 1:
                this.addToListError("SMP_DAP_5", position);
                break;
            case 2:
                this.addToListError("SMP_DAP_4", position);
                break;
        }
    }

    onSelectDay(val: any, index: number) {
        this.validateBusinessDays();
    }

    validateBusinessDays() {
        let businessDays = this.allSchedule.filter(x => x.day !== CommonConstants.ORDERED_DAYS_OF_WEEK[5]);
        let selectedDays = businessDays.filter(x => x.selectedDay === true);
        if (selectedDays.length === 4) {
            businessDays.forEach(function (element) {
                if (element.selectedDay === false) {
                    element.isDisabled = true;
                    element.preferredSelected = '-1';
                    element.latestSelected = '-1';

                }
            });
        }
        else {
            businessDays.forEach(function (element) {
                element.isDisabled = false;
            });
        }
    }

    removeFixedErrors(value: number) {

        //Verify Error is not udenfined
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }

        this.allSchedule[value].error = new ErrorSchedule();
        return this.Errors.filter(function (elem) {
            return elem.position != value;
        });
    }

    addToListError(errorCode: string, position: number) {

        let error = new ErrorSchedule();
        error.message = this._translateData.transform(SCHEDULE_ERROR_MESSAGES.find(err => err.code === errorCode).key);
        error.code = errorCode;
        error.position = position;

        let findExistingError;

        //Verify Error is not udenfined
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }

        //Verify if the error exists
        findExistingError = this.Errors.find(err => err.code === errorCode && err.position === error.position);

        //If no error code found in the list, then add to the error list
        if (!(typeof findExistingError !== 'undefined' && findExistingError.code.length > 0)) {
            this.Errors.push(error);
            this.allSchedule[position].error = error;
        }
    }

    validateScheduleDSP(position: number) {
        let result = 0;
        this.Errors = this.removeFixedErrors(position);

        let daySelector = this.allSchedule[position].selectedDay ? "1" : "0";
        let preferred =
            this.allSchedule[position].preferredSelected != "-1" ? "1" : "0";
        let latest =
            this.allSchedule[position].latestSelected != "-1" ? "1" : "0";
        let saturday =
            this.allSchedule[position].shortDay == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[5]
                ? "1"
                : "0";//If user select a DDL on saturday row
        let option = daySelector.concat(preferred, latest, saturday);
        let businessDays = this.allSchedule.filter(
            x => x.day !== CommonConstants.ORDERED_DAYS_OF_WEEK[5]
        );
        let selectedDays = businessDays.filter(x => x.selectedDay === true);

        let valDays: any = selectedDays.filter(x => x.day === this.allSchedule[position].day);

        if (selectedDays.length >= 1 && selectedDays.length <= 4 && (daySelector == '0' && preferred !== '0' && latest !== '0' && valDays > 0)) {
            return 0;
        }

        if (this.allSchedule[position].shortDay == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[5] && this.allSchedule[position].selectedDay == true && selectedDays.length < 1) {
            this.addToListError("DSP_16", position);
            return 0;
        }

        switch (option) {
            case "1110":
            case "1111":
                return this.validateOneHourDifference(
                    this.allSchedule[position].preferredSelected,
                    this.allSchedule[position].latestSelected
                );
            case "0100":
                this.addToListError("DSP_11", position);
                break;
            case "0000":
                this.addToListError("DSP_3", position);
                break;
            case "1011":
                this.addToListError("DSP_4", position);
                break;
            case "1101":
                this.addToListError("DSP_5", position);
                break;
            case "1001":
                this.addToListError("DSP_6", position);
                break;
            case "1010":
                this.addToListError("DSP_7", position);
                break;
            case "1100":
                this.addToListError("DSP_8", position);
                break;
            case "1000":
                this.addToListError("DSP_9", position);
                break;

            case "0110":
                this.addToListError("DSP_10", position);
                break;
            case "0010":
                this.addToListError("DSP_12", position);
                break;
            case "0111":
                this.addToListError("DSP_13", position);
                break;
            case "0101":
                this.addToListError("DSP_14", position);
                break;
            case "0011":
                this.addToListError("DSP_15", position);
                break;
            default:
                return 0;
        }
        return result;
    }

    createRequest() {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        let data: LocationDetailsSession = new LocationDetailsSession();
        data = this.sessionData.locationDetails;

        this._getPickupScheduleDetailsRequest.address.AddressLine1 = data.address1;
        this._getPickupScheduleDetailsRequest.address.AddressLine2 = typeof (data.address2) === 'undefined' || data.address2 == null ? '' : data.address2;
        this._getPickupScheduleDetailsRequest.address.CityTown = data.city;
        this._getPickupScheduleDetailsRequest.address.StateProvince = data.state;
        this._getPickupScheduleDetailsRequest.address.CountryCode = data.countryKey;
        this._getPickupScheduleDetailsRequest.address.PostalCode = data.postal;

    }

    focusInput(item: any) {
        if (item.id !== undefined) {
            document.getElementById(item.id).focus();
        }
    }

}